function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { createContext, useContext, useReducer } from "react";
import { composeDataMethods } from "@lululemon/mwa-utils";
const GlobalContext = /*#__PURE__*/createContext();
export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (context === undefined) {
    throw new Error("useGlobalContext must be used within a GlobalContext Provider");
  }
  return context;
};
const contextReducer = (state, action) => {
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (action.type) {
    case "updateDeviceType":
      {
        return _extends({}, state, {
          deviceType: action.payload
        });
      }
    default:
      {
        throw new Error(`Unhandled action type: ${action.type}`);
      }
  }
};
export const ContextConsumer = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(GlobalContext.Consumer, null, context => {
    if (context === undefined) {
      throw new Error("GlobalContext Consumer must be used within a GlobalContext Provider");
    }
    return children(context);
  });
};
const withGlobalContext = Component => {
  const WithGlobalContext = props => {
    const {
      deviceType = {}
    } = props;
    const [context, dispatch] = useReducer(contextReducer, {
      deviceType
    });
    const value = {
      context,
      dispatch
    };
    return /*#__PURE__*/React.createElement(GlobalContext.Provider, {
      value: value
    }, /*#__PURE__*/React.createElement(Component, props));
  };
  return composeDataMethods(Component, {})(WithGlobalContext);
};
export default withGlobalContext;